// tokenService.js

const storage = sessionStorage; // Change to localStorage if you want it to persist

export const tokenService = {
  setToken(token) {
    storage.setItem('xsd', token);
  },

  getToken() {
    return storage.getItem('xsd');
  },

  removeToken() {
    storage.removeItem('xsd');
  },
};

//export const BASE = "https://dagi-production-2ae3.up.railway.app/api"
export const BASE = "https://api.dagifeed.com/api"
//export const BASE = "http://localhost:3000/api"
//export const IMAGEBASE = "https://dagi-production-2ae3.up.railway.app"
export const IMAGEBASE = "https://api.dagifeed.com"
